//Special Attention
export const configKey_Tag_SpecialAttentionTags = 'tag__special-attention';
//# sourceMappingURL=config-keys.js.map